export class Logger {
  private enabled: boolean = true;
  private logger: Console = console;
  private name: string;

  constructor(name: string) {
    this.name = name;
  }

  public enable() {
    this.enabled = true;
  }

  public disable() {
    this.enabled = false;
  }

  public info(message: string, ...args: unknown[]) {
    if (this.enabled) {
      this.logger.info(`[${this.name}]`, message, ...args);
    }
  }

  public error(message: string, ...args: unknown[]) {
    if (this.enabled) {
      this.logger.error(`[${this.name}]`, message, ...args);
    }
  }

  public warn(message: string, ...args: unknown[]) {
    if (this.enabled) {
      this.logger.warn(`[${this.name}]`, message, ...args);
    }
  }

  public debug(message: string, ...args: unknown[]) {
    if (this.enabled) {
      this.logger.debug(`[${this.name}]`, message, ...args);
    }
  }

  public trace(message: string, ...args: unknown[]) {
    if (this.enabled) {
      this.logger.trace(`[${this.name}]`, message, ...args);
    }
  }

  // has all of the same methods as console
  public log(message: string, ...args: unknown[]) {
    if (this.enabled) {
      this.logger.log(`[${this.name}]`, message, ...args);
    }
  }

  public table(data: string[]) {
    if (this.enabled) {
      this.logger.table(`[${this.name}]`, data);
    }
  }

  public group(message: string, ...args: unknown[]) {
    if (this.enabled) {
      this.logger.group(`[${this.name}]`, message, ...args);
    }
  }

  public groupEnd() {
    if (this.enabled) {
      this.logger.groupEnd();
    }
  }

  public time(message: string) {
    if (this.enabled) {
      this.logger.time(message);
    }
  }

  public timeEnd(message: string) {
    if (this.enabled) {
      this.logger.timeEnd(message);
    }
  }

  public timeLog(message: string, ...args: unknown[]) {
    if (this.enabled) {
      this.logger.timeLog(message, ...args);
    }
  }
}

export const scribeLogger = new Logger("stitch-scribe");

export const scribeClientLogger = new Logger("stitch-scribe-client");
